import { render, staticRenderFns } from "./OrganizationManagerAuthorityInput.vue?vue&type=template&id=b526c3f8&"
import script from "./OrganizationManagerAuthorityInput.vue?vue&type=script&lang=js&"
export * from "./OrganizationManagerAuthorityInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports